import { useEffect, useRef } from "react";

import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { InView } from "react-intersection-observer";

import useThresholdOptions from "@/utils/useThresholdOptions";

const RowIntersection = ({ children, onIntersect, slug }) => {
  const { asPath } = useRouter();
  const slugFromUrl = asPath.match(/#(.+)/)?.[1];
  const wrapperRef = useRef();
  const threshold = useThresholdOptions();

  const scrollOptions = {
    behavior: "instant",
    block: "start",
  };

  // Scrolls to anchor from URL after render
  useEffect(() => {
    let timer;
    if (slug === slugFromUrl) {
      if (wrapperRef?.current) {
        timer = setTimeout(
          () => wrapperRef?.current.scrollIntoView(scrollOptions),
          0,
        );
      }
    }
    return () => {
      clearTimeout(timer);
    };
  }, [slug]);

  /* role and region are added only to the CEHero row because the other content rows have an HTML heading that tells screen reader users and AT where the row begins and ends, whereas the CEHero row does not
   */
  return (
    <InView
      threshold={threshold}
      as="div"
      id={slug}
      onChange={(inView, entry) => inView && onIntersect(entry)}
    >
      <div ref={wrapperRef} tabIndex="-1">
        {children}
      </div>
    </InView>
  );
};

RowIntersection.propTypes = {
  children: PropTypes.element.isRequired,
  onIntersect: PropTypes.func.isRequired,
  rowTitle: PropTypes.string.isRequired,
  rowIndex: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
};

export default RowIntersection;
